module.exports = __webpack_public_path__ + "img/l_c6.c7688429.png";